import Base from "../base";
import { SateliteHistorySameBuilding } from "./sateliteHistorySameBuilding";

/* サテライト履歴 */
export interface SateliteHistory extends Base {
  /** ID */ id: number;
  /** 事業所ID */ office_id: number;
  /** 主たる事業所ID（サテライト） */ parent_office_id: number;
  /** 開始日 */ start_date: string;
  /** 終了日 */ end_date: string;
  /** サテライト番号 */ satelite_no: number;
  /** 事業所名 */ name: string;
  /** 郵便番号 */ post_code: string;
  /** 都道府県 */ pref: number;
  /** 市区 */ city: string;
  /** 町村番地 */ area: string;
  /** 建物 */ building: string;
  /** 市外局番 */ tel_area: string;
  /** 市内局番 */ tel_city: string;
  /** 加入者番号 */ tel_num: string;
  /** 市外局番 */ fax_area: string;
  /** 市内局番 */ fax_city: string;
  /** 加入者番号 */ fax_num: string;
  /** 地域区分 0:未選択 1:1級 2:2級 3:3級 4:4級 5:5級 6:6級 7:7級 8:その他 */ area_div: number;
  /** 介護_特別地域加算 0:なし 1:あり */ care_special_area_div: number;
  /** 介護_同一建物に居住する利用者の減算 0:なし 1:あり */ care_riyousya_gensan: number;
  /** 介護_中山間地域等小規模事業所加算 0:加算なし 1:加算あり（予防・介護） 2:加算あり（予防） 3:加算あり（介護） */ care_small_office_scale_add: number;
  /** 医療_特別地域対象（ステーション） 0:対象外 1:対象 */ medical_special_area_station_div: number;
  /** 作成日時 */ created_at: string;
  /** 更新日時 */ updated_at: string;
  /** 削除日時 */ deleted_at: string;
  /** 開始日（和暦） */ start_date_wareki: string;
  /** 終了日（和暦） */ end_date_wareki: string;
  /** 同一建物 */ satelite_history_same_buildings: SateliteHistorySameBuilding[];
  /** コメント */ comment: string;
  /** 緯度 */ latitude: number;
  /** 経度 */ longitude: number;
}

export const setSateliteHistory = (): SateliteHistory => ({
  id: 0,
  office_id: 0,
  parent_office_id: 0,
  start_date: "",
  end_date: "",
  satelite_no: 0,
  name: "",
  post_code: "",
  pref: 0,
  city: "",
  area: "",
  building: "",
  tel_area: "",
  tel_city: "",
  tel_num: "",
  fax_area: "",
  fax_city: "",
  fax_num: "",
  area_div: 0,
  care_special_area_div: 0,
  care_riyousya_gensan: 0,
  care_small_office_scale_add: 0,
  medical_special_area_station_div: 0,
  created_at: "",
  updated_at: "",
  deleted_at: "",
  start_date_wareki: "",
  end_date_wareki: "",
  satelite_history_same_buildings: [],
  comment: "",
  latitude: 0,
  longitude: 0
});

export const DefaultSateliteHistory = setSateliteHistory;
